import Swal from 'sweetalert2';
import { randomString } from '@SHARED/js/helpers/misc';
import template from './JsonContentEditorModule.html';
import FroalaField from './fields/FroalaField';
import GalleryField from './fields/GalleryField';
import EmployeesField from './fields/EmployeesField';
import ContactFormField from './fields/ContactFormField';
import ContactFormSimpleField from './fields/ContactFormSimpleField';
import MediaGalleryModule from '../../modules/MediaGallery/MediaGalleryModule';
import NewsletterFormField from './fields/NewsletterFormField';

export default {
  template,

  components: {
    FroalaField,
    GalleryField,
    EmployeesField,
    ContactFormField,
    ContactFormSimpleField,
    MediaGalleryModule,
    NewsletterFormField,
  },

  props: {
    initContent: {
      type: String,
      default: '[]',
    },
    inputField: {
      type: String,
      required: true,
    },
    relatedId: {
      type: Number,
      required: true,
    },
    relatedModel: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      content: [],
      selectAddField: '',
      mediaPath: window.cdnPath,
      isDirty: false,
      renderComponents: true, // Use this to trigger 'destroy' on field components
      errors: [],
    };
  },

  created() {
    try {
      // Parse data, and add uniqueId to each content item for later reference
      const parsedContent = JSON.parse(this.initContent);
      this.content = parsedContent.map((item) => {
        item.uniqueId = randomString();

        return item;
      });
    } catch (e) {
      this.errors.push(e);
    }

    this.$watch(
      'content',
      () => {
        this.isDirty = true;
      },
      { deep: true },
    );
  },

  mounted() {
    this.$nextTick(() => {
      $('#contentGridForm').on('submit', () => {
        window.onbeforeunload = null;
        window.loader.show();
        this.renderComponents = false;
      });

      window.onbeforeunload = (() => {
        if (this.isDirty) {
          setTimeout(() => {
            window.location.hash = '#page';
            $('.nav-tabs a[href="#page"]').tab('show');
          }, 100);

          return 'Endringer i innhold er ikke lagret! Er du sikker på du vil fortsette uten å lagre?';
        }

        return null;
      });
    });
  },

  watch: {
    selectAddField(val) {
      if (val !== null && val.length) {
        if (val === 'froala_content') {
          this.addFroalaField();
        } else if (val === 'gallery') {
          this.addGalleryField();
        } else if (val === 'employees') {
          this.addEmployeesField();
        } else if (val === 'contact_form') {
          this.addContactFormField();
        } else if (val === 'contact_form_simple') {
          this.addContactFormSimpleField();
        } else if (val === 'newsletter_form') {
          this.addNewsletterFormField();
        }
        this.selectAddField = '';
      }
    },
  },

  computed: {
    encodedContent() {
      // Remove 'uniqueId' from encoded content so that they do not get save to DB
      return JSON.stringify(this.content.map((item) => {
        const newObject = Object.assign({}, item);
        delete newObject.uniqueId;

        return newObject;
      }));
    },
  },

  methods: {
    addFroalaField(contentIndex = null) {
      contentIndex = contentIndex || this.content.length;
      this.content.splice(contentIndex, 0, {
        uniqueId: randomString(),
        froala_content: '<p>Make something amazing</p>',
      });
    },

    addGalleryField(contentIndex = null) {
      contentIndex = contentIndex || this.content.length;
      this.content.splice(contentIndex, 0, { gallery: [] });
    },

    addEmployeesField(contentIndex = null) {
      contentIndex = contentIndex || this.content.length;
      this.content.splice(contentIndex, 0, { departmentTitle: '', employees: [] });
    },

    addContactFormField(contentIndex = null) {
      contentIndex = contentIndex || this.content.length;
      this.content.splice(contentIndex, 0, {
        contact_form: {
          title: 'Kontaktskjema',
          mailTo: 'kraftex@kraftex.no',
        },
      });
    },

    addContactFormSimpleField(contentIndex = null) {
      contentIndex = contentIndex || this.content.length;
      this.content.splice(contentIndex, 0, {
        contact_form_simple: {
          title: 'Kontaktskjema',
          mailTo: 'kraftex@kraftex.no',
        },
      });
    },

    addNewsletterFormField(contentIndex = null) {
      contentIndex = contentIndex || this.content.length;
      this.content.splice(contentIndex, 0, {
        newsletter_form: {
          title: 'Hold deg oppdatert',
          mailTo: 'kraftex@kraftex.no',
          content: 'Siste nytt fra bransjen direkte til din innboks.Vi sender e-post 1-2 ganger pr. mnd.',
        },
      });
    },

    insertAndShift(arr, from, to) {
      const cutOut = arr.splice(from, 1)[0]; // cut the element at index 'from'
      arr.splice(to, 0, cutOut);            // insert it at index 'to'
    },

    moveFieldUp(contentIndex) {
      if (contentIndex !== 0) {
        this.insertAndShift(this.content, contentIndex, contentIndex - 1);
      }
    },

    moveFieldDown(contentIndex) {
      if (this.content.length !== contentIndex) {
        this.insertAndShift(this.content, contentIndex, contentIndex + 1);
      }
    },

    deleteField(contentIndex) {
      Swal.fire({
        title: 'Bekreft sletting',
        text: 'Er du sikker på du vil fjerne dette feltet?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#DD6B55',
        confirmButtonText: 'Ja, fjern',
        cancelButtonText: 'Avbryt',
      }).then((result) => {
        if (result.value) {
          this.content.splice(contentIndex, 1);
        }
      });
    },

  },
};
